/**
 * Custom select cell renderer component
 *
 * Custom cell for ag-grid that shows a select options input.
 */
import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { get, isFunction } from 'lodash';

import { CUSTOM_XUX_GRID_ACTIONS } from '@shared/types';
import { XVISelectRendererComponent } from '../select-renderer/select-renderer.component';
import { ICellRendererParams } from 'ag-grid-community';
import { setFocusedCell } from '@app/components/xvi-grid/decorators/set-focused-cell.decorator';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-custom-select-renderer',
  templateUrl: 'custom-select-renderer.component.html',
  styleUrls: ['../select-renderer/select-renderer.component.scss'],
})
export class XVICustomSelectRendererComponent
  extends XVISelectRendererComponent
  implements AgRendererComponent
{
  public isPositionTop: boolean = false;

  public isErrorFn: (params: ICellRendererParams) => boolean;

  public placeholder: string = null;

  /**
   * Number of items to show in the dropdown before scrolling is needed. Default is null
   */
  public dropdownShownItemCount: number = null;

  /** Whether to show a search input inside the dropdown for fuzzy filtering. */
  public searchable: boolean = false;

  public agInit(params: ICellRendererParams): void {
    super.agInit(params);
    this.isPositionTop = get(this.params, 'isPositionTop', false);
    this.placeholder = get(this.params, 'placeholder', this.placeholder);

    this.dropdownShownItemCount = get(
      this.params,
      'dropdownShownItemCount',
      this.dropdownShownItemCount,
    );

    this.isErrorFn = get(this.params, 'isErrorFn', null);
    this.searchable = get(this.params, 'searchable', this.searchable);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public finishEditing(value: string): void {
    const action = this.createAction();

    let isStillCallEmit = true;
    if (isFunction(this.onValueChange)) {
      isStillCallEmit = this.onValueChange(action.payload as any);
    }

    if (isStillCallEmit && isFunction(this.emitItemAction)) {
      this.emitItemAction(action);
    }

    this.emitExitEditingAction(false);
  }

  public isError(): boolean {
    return isFunction(this.isErrorFn) ? this.isErrorFn(this.params) : false;
  }

  private emitExitEditingAction(navigateToNextRow = true): void {
    const exitEditingAction = {
      type: CUSTOM_XUX_GRID_ACTIONS.EXIT_EDITING_MODE,
      payload: {
        navigateToNextRow,
      },
    };
    this.emitItemAction(exitEditingAction);
  }

  @setFocusedCell()
  public onFocusIn(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }
}
